/* eslint-disable */
export default {
  status: 'Estado',
  acceptQueueCalls: 'Aceptar llamadas en cola',
  callQueueDisabledReason:
    'El administrador de su empresa gestiona esta configuración.',
  callQueueManagement: 'Gestionar colas',
} as const;

// @key: @#@"status"@#@ @source: @#@"Status"@#@
// @key: @#@"acceptQueueCalls"@#@ @source: @#@"Accept call queue calls"@#@
// @key: @#@"callQueueDisabledReason"@#@ @source: @#@"This setting is managed by your company administrator."@#@
// @key: @#@"callQueueManagement"@#@ @source: @#@"Manage queues"@#@
